// extracted by mini-css-extract-plugin
module.exports = {"footer__wrap":"Footer_footer__wrap__2dwRh","footer__links":"Footer_footer__links__1d0oe","partners":"Footer_partners__2D_z9"};